import { SHOW_VIDEO, CLOSE_VIDEO } from './BannerActionTypes';

export function updateVideo() {
  return (dispatch) => {
    dispatch({
      type: SHOW_VIDEO,
    });
  };
}

export function closeVideo() {
  return (dispatch) => {
    dispatch({
      type: CLOSE_VIDEO,
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/Banner/Banner.actions.js